import { render, staticRenderFns } from "./purchaseDiscountsHistory.vue?vue&type=template&id=6234e880"
import script from "./purchaseDiscountsHistory.vue?vue&type=script&lang=js"
export * from "./purchaseDiscountsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports